import { render } from "./ShipmentDashboard.vue?vue&type=template&id=4d47ed50&scoped=true"
import script from "./ShipmentDashboard.vue?vue&type=script&lang=js"
export * from "./ShipmentDashboard.vue?vue&type=script&lang=js"

import "./ShipmentDashboard.vue?vue&type=style&index=0&id=4d47ed50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d47ed50"]])

export default __exports__